import { ReactElement } from "react";
import { TreeAccordion } from "client/Components";
import { localize } from "client_legacy/ndaw/culture";

export type BookmarksSideBarMenuProps = {
	isSelected: boolean;
	onClick(): void;
};

export const BookmarksSideBarMenu = (props: BookmarksSideBarMenuProps): ReactElement => {
	const {
		isSelected,
		onClick
	} = props;

	return (
		<TreeAccordion trackingId="bookmarks-sidebar">
			<TreeAccordion.Node>
				<TreeAccordion.Item
					icon="star-filled"
					iconColor="bookmark"
					isSelected={isSelected}
					onClick={onClick}
					expansionToggle="hidden"
					trackingId="bookmarks"
				>
					{localize("_Bookmarks")}
				</TreeAccordion.Item>
			</TreeAccordion.Node>
		</TreeAccordion>
	);
};

BookmarksSideBarMenu.displayName = "BookmarksSideBarMenu";